import { FormStore } from '@estee/elc-form';
import { IFormValues } from '@estee/elc-form/typings/views/Form';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IFormItem } from '~domain/entities/Config';
import { classes } from '~utils/Classes';
import { FormItemAdapter } from './FormItemAdapter';

export interface IFieldsetProps {
    name: string;
    inputLabel: string;
    items: IFormItem[];
    formStore: FormStore<IFormValues>;
}

export const TEST_ID_FIELD_SET = 'iam-fieldset';

@observer
export class Fieldset extends React.Component<IFieldsetProps> {
    render() {
        const { name, inputLabel, items, formStore } = this.props;
        const rootClassName = classes('iam-fieldset', `iam-fieldset-${name}`);

        return (
            <fieldset className={rootClassName} data-test-id={TEST_ID_FIELD_SET}>
                <legend>{inputLabel}</legend>
                {items.map((item: IFormItem) => (
                    <FormItemAdapter key={item.name} {...item} formStore={formStore} />
                ))}
            </fieldset>
        );
    }
}
